import React from "react";

const ImageConverterTutorialSvg = () => {
    
    return (
        <svg width="292"
             height="101"
             viewBox="0 0 292 101"
             className="fill-[#1A1A1A] dark:fill-white scale-75  sm:scale-100"
             fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M78.0055 5.5H21.9961C12.6242 5.5 5 13.1242 5 22.4961V78.5055C5 87.8774 12.6242 95.5 21.9961 95.5H78.0055C87.3758 95.5 95 87.8758 95 78.5055V22.4961C95 13.1242 87.3758 5.5 78.0055 5.5ZM21.9961 8.6043H78.0055C85.6654 8.6043 91.8957 14.8362 91.8957 22.4961V74.7586L80.3772 63.2401C78.915 61.7764 76.9624 60.9693 74.8794 60.9693C72.798 60.9693 70.8454 61.7764 69.3833 63.2385L56.2816 76.3216L30.1325 50.1725C28.6703 48.7088 26.7255 47.9032 24.658 47.9032C22.5905 47.9032 20.6472 48.7104 19.1836 50.1725L8.10586 61.2502V22.4961C8.1043 14.8346 14.3346 8.6043 21.9961 8.6043ZM8.1043 78.5055V65.6397L21.3768 52.3672C23.1322 50.6118 26.1822 50.6133 27.9377 52.3672L67.9677 92.3957H21.9961C14.3346 92.3957 8.1043 86.1654 8.1043 78.5055ZM78.0055 92.3957H72.3557L58.4779 78.5179L71.578 65.4348C73.3351 63.6793 76.4285 63.6809 78.1824 65.4348L91.8647 79.117C91.5418 86.4913 85.4589 92.3957 78.0055 92.3957Z"

            />
            <g clip-path="url(#clip0_4627_1585)">
                <path
                    d="M150.02 22.5L148.66 23.83L158.37 33.55H130V35.45H158.37L148.66 45.18L150.02 46.5L162 34.5L150.02 22.5Z"

                />
            </g>
            <g clip-path="url(#clip1_4627_1585)">
                <path
                    d="M141.98 54.5L143.34 55.83L133.63 65.55H162V67.45H133.63L143.34 77.18L141.98 78.5L130 66.5L141.98 54.5Z"

                />
            </g>
            <path
                d="M270.005 5.5H213.996C204.624 5.5 197 13.1242 197 22.4961V78.5055C197 87.8774 204.624 95.5 213.996 95.5H270.005C279.376 95.5 287 87.8758 287 78.5055V22.4961C287 13.1242 279.376 5.5 270.005 5.5ZM213.996 8.6043H270.005C277.665 8.6043 283.896 14.8362 283.896 22.4961V74.7586L272.377 63.2401C270.915 61.7764 268.962 60.9693 266.879 60.9693C264.798 60.9693 262.845 61.7764 261.383 63.2385L248.282 76.3216L222.132 50.1725C220.67 48.7088 218.725 47.9032 216.658 47.9032C214.591 47.9032 212.647 48.7104 211.184 50.1725L200.106 61.2502V22.4961C200.104 14.8346 206.335 8.6043 213.996 8.6043ZM200.104 78.5055V65.6397L213.377 52.3672C215.132 50.6118 218.182 50.6133 219.938 52.3672L259.968 92.3957H213.996C206.335 92.3957 200.104 86.1654 200.104 78.5055ZM270.005 92.3957H264.356L250.478 78.5179L263.578 65.4348C265.335 63.6793 268.428 63.6809 270.182 65.4348L283.865 79.117C283.542 86.4913 277.459 92.3957 270.005 92.3957Z"

            />
            <defs>
                <clipPath id="clip0_4627_1585">
                    <rect width="32" height="30" fill="white" transform="translate(130 19.5)" />
                </clipPath>
                <clipPath id="clip1_4627_1585">
                    <rect width="32" height="30" fill="white" transform="matrix(-1 0 0 1 162 51.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ImageConverterTutorialSvg;
